import { useNavigate, useLocation, createSearchParams } from "react-router-dom";
import useStore from "../store";

const useNavigateWithVars = () => {
  const navigate = useNavigate();
  const urlVars = useLocation().search;
  const character = useStore((state) => state.character);
  const uid = useStore((state) => state.uid);
  const hostid = useStore((state) => state.hostid);
  const isHost = useStore((state) => state.isHost);

  const navigateWithVars = (path) => {
    let newPath = path;
    console.log("Navigate to", path, urlVars);
    if (urlVars) {
      newPath += urlVars;
    }

    if (!urlVars.includes("uid=") && uid) {
      newPath += `?uid=${uid}`;
    }
    if (!urlVars.includes("c=") && character) {
      newPath += `&c=${character.uid}`;
    }
    if (!urlVars.includes("host=") && isHost && hostid) {
      newPath += `&host=${hostid}`;
    }

    // const newSearch = {
    //   uid: uid,
    //   c: character?.attributes?.uid,
    //   host: hostid,
    // };

    console.log(
      "Navigate to",
      newPath
      //createSearchParams(newSearch).toString()
    );

    navigate(newPath, {
      replace: true,
      //search: createSearchParams(newSearch).toString(),
    });
  };

  return navigateWithVars;
};

export { useNavigateWithVars };
